import * as React from 'react';
import GoogleMap, { Props as MapProps } from 'google-map-react';

import { LeafletMapOptions } from 'ha/types/LeafletMapOptions';
import { withIntl, IntlProps } from 'ha/i18n';
import { ConfigConsumer } from 'ha/helpers/config';
import pepitaMapLoader from './pepitaMapLoader';

interface Props {
  bootstrapURLKeys?: {
    key: string;
    language: string;
  };
  onDrag?: () => void;
  children: React.ReactNode;
  options: MapProps['options'] | LeafletMapOptions;
}

const HaGoogleMap: React.SFC<Props & IntlProps & MapProps> = ({
  bootstrapURLKeys = {},
  children,
  intl,
  ...rest
}) => (
  <ConfigConsumer>
    {config => (
      <GoogleMap
        {...rest}
        googleMapLoader={
          config.mapProvider === 'pepita' ? pepitaMapLoader : undefined
        }
        bootstrapURLKeys={{
          key:
            config.mapProvider === 'pepita'
              ? config.immobiliare.maps_key
              : config.google.maps_key,
          language: intl.locale,
          ...bootstrapURLKeys,
        }}
      >
        {children}
      </GoogleMap>
    )}
  </ConfigConsumer>
);

export default withIntl(HaGoogleMap);
